enum Variation {
    Standard = 'standard',
    Subpage = 'subpage',
    Homepage = 'homepage',
    Login = 'login',
}

export default Variation;
